module.exports = __webpack_public_path__ + "img/2021AlloteeVisayasTiktok.fe585fe4.jpg";